import { ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledTextAreaContainer = styled.div`
  position: relative;
  padding: 0.5rem 1rem;
  border: 1px solid ${(props: ThemeProps) => props.theme.mbColors.lightGray};
  border-radius: 16px;

  &[data-focused='true'] {
    border-color: ${(props: ThemeProps) => props.theme.mbColors.pink};
  }

  textarea {
    font-size: 14px;
    line-height: 24px;
    resize: none;
  }

  .subtitle {
    /* position: absolute;
  top: 2px;
  left: 16px; */
    width: 100%;
    /* background-color: ${(props: ThemeProps) => props.theme.colors.white}; */
  }
`
